import React from 'react';
import { X, Calendar, Clock3 } from 'lucide-react';

const ActiveShipsModal = ({ onClose, ships }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-11/12 max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="px-6 py-4 border-b flex justify-between items-center bg-indigo-900">
          <div>
            <h3 className="text-xl font-semibold text-white">Active Ships</h3>
            <p className="text-sm text-white mt-1">Overview of all active ships</p>
          </div>
          <button
            onClick={onClose}
            className="text-white hover:text-gray-300"
          >
            <X size={24} />
          </button>
        </div>
        <div className="p-6 overflow-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {ships.map((ship, index) => (
              <div key={index} className="bg-white rounded-lg border border-gray-200 shadow-sm hover:shadow-md transition-shadow p-4">
                <div className="flex items-start justify-between">
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900">{ship.name}</h4>
                    <p className="text-sm text-gray-600 mt-1">Ship ID: {ship.id}</p>
                  </div>
                </div>
                <div className="mt-4">
                  <div className="flex items-center text-sm text-gray-500 mb-2">
                    <Calendar size={16} className="mr-2" />
                    Project: {ship.project_name || 'N/A'}
                  </div>
                  <div className="flex items-center text-sm text-gray-500 mb-3">
                    <Clock3 size={16} className="mr-2" />
                    Status: Active
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActiveShipsModal;